import React, { useState } from 'react'
import { Form } from 'react-bootstrap';
function Banktransfer({ register, setValue, errors, clearErrors, setbankReceipt, bankReceiptErr, setBankReceiptErr }) {
    const [receipt, setreceipt] = useState()
    const [preview, setPreview] = useState(null);

    const fileChangeHandler = (e) => {
        if (e.target.files[0]) {
            setbankReceipt(e.target.files[0])
            setValue('file', e.target.files[0])
            setPreview(URL.createObjectURL(e.target.files[0]));
            setBankReceiptErr("")
        }
    };
    const closeHandler = () => {
        setPreview(null)
        setValue('file', null)
        setbankReceipt(null)
    }
    console.log("====preview==", preview)
    console.log("==errorrs==", bankReceiptErr)
    return (
        <>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Upload Receipt</Form.Label>
                <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={fileChangeHandler}
                    isInvalid={!!bankReceiptErr}
                    
                />
                <Form.Control.Feedback type="invalid">
                    {bankReceiptErr}
                </Form.Control.Feedback>
            </Form.Group>
            {preview && (
                <div className="image-preview position-relative d-inline-block rounded shadow-sm overflow-hidden">
                    {/* <button
                        type="button"
                        className="custom-close-btn position-absolute top-0 end-0 m-1"
                        aria-label="Close"
                        onClick={closeHandler}
                    >
                        &times;
                    </button> */}
                    <img src={preview} className="preview-img" alt="Preview" />
                </div>
            )}



        </>
    )
}

export default Banktransfer